import { dequal } from 'dequal';
import type { AnyAction } from 'redux';

import {
  PAGE_ID_CLASSIFY,
  PAGE_ID_MANAGE,
  PAGE_ID_PAY_AND_POST_V2,
  PAGE_ID_SELECT_AD_TYPE,
  PAGE_ID_WRITE,
} from 'src/app/shared/constants/pageUid';
import type { Progress } from 'src/types/appState';

// @TODO: Consider listing all page id's here (typeof PAGE_ID_CLASSIFY etc)
type PageId = string;

type ProgressState = {
  currentPageId: PageId;
  furthestPageId: PageId;
  isValidObj: Record<PageId, boolean>;
};

const defaultState: ProgressState = {
  currentPageId: PAGE_ID_CLASSIFY,
  furthestPageId: PAGE_ID_CLASSIFY,
  isValidObj: {
    [PAGE_ID_CLASSIFY]: false,
    [PAGE_ID_SELECT_AD_TYPE]: false,
    [PAGE_ID_WRITE]: false,
    [PAGE_ID_MANAGE]: false,
    [PAGE_ID_PAY_AND_POST_V2]: false,
  },
};

const UPDATE_PAGE_PROGRESS = 'app/progress/UPDATE_PAGE_PROGRESS';
const UPDATE = 'app/progress/UPDATE';
const RESET = 'app/progress/RESET';

export const actionResetProgress = () => ({
  type: RESET,
});

export const actionUpdateProgress = (value: Progress) => ({
  type: UPDATE,
  value,
});

export const actionUpdatePageProgress = (pageId: string, value: boolean) => ({
  type: UPDATE_PAGE_PROGRESS,
  value: {
    pageId,
    value,
  },
});

export default (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case UPDATE_PAGE_PROGRESS: {
      const newState = {
        ...state,
        isValidObj: {
          ...state.isValidObj,
          [action.value.pageId]: action.value.value,
        },
      };
      return dequal(state, newState) ? state : newState;
    }
    case UPDATE: {
      return dequal(action.value, state) ? state : action.value;
    }
    case RESET: {
      return defaultState;
    }
    default: {
      return state;
    }
  }
};
